module.exports = __webpack_public_path__ + "static/media/GymHolic.c8499bc0.png";